/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var tlpsDatiAggiuntiviCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    $state,
    domainSrvc,
    $q,
    definizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.$state = $state;
    this.domainSrvc = domainSrvc;
    this.$q = $q;
    this.definizioneSrvc = definizioneSrvc;

    this.emailDisabled = true;
    this.telefonoDisabled = true;

    this.disableIndirizzoDiversoResidenza = true;

    this.modalitaRitiroList = [];
    this.comuni = [];
    this.province = [];
    this.localita = [];
    this.capFiltrati = [];

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    this.ndgRappresentanteDaMostrare = null;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name controllaTelefono
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Verifica se la email e il telefono sono valorizzati, se lo sono, disabilita il campo input.
     */
    this.controllaTelefono = function () {
      if (!self.propostaTelepassSrvc.datiCliente.recapito.telefono) {
        self.telefonoDisabled = false;
      }
    };

    /**
     * @ngdoc method
     * @name controllaEmail
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Verifica se la email e il telefono sono valorizzati, se lo sono, disabilita il campo input.
     */
    this.controllaEmail = function () {
      if (!self.propostaTelepassSrvc.datiCliente.recapito.email) {
        self.emailDisabled = false;
      }
    };

    this.propostaTelepassSrvc.datiValidi = function () {
      var errori = false;

      if (!self.propostaTelepassSrvc.datiCliente.email) {
        var message = {};
        message.type = 'E';
        message.message = 'Email obbligatoria';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      if (!self.propostaTelepassSrvc.datiCliente.telefono) {
        var message = {};
        message.type = 'E';
        message.message = 'Numero di telefono obbligatorio';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia stata selezionata la modalità di ritiro
      if (!self.propostaTelepassSrvc.datiPratica.modalitaRitiro) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare la modalità di ritiro';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto la modalità di ritiro 'filiale', sia valorizzato il codice apparato
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'F' &&
        !self.propostaTelepassSrvc.datiPratica.codiceApparato
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice apparato';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto la modalità di ritiro 'filiale' e il apparato aggiuntivo, sia valorizzato il codice apparato aggiuntivo
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'F' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        !self.propostaTelepassSrvc.datiPratica.codiceApparatoTwin
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice apparato twin';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, siano valorizzate la nazione e il numero di targa
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        (!self.propostaTelepassSrvc.datiPratica.nazioneTarga || !self.propostaTelepassSrvc.datiPratica.targa)
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si devono valorizzare la nazione e la targa';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto il apparato aggiuntivo, siano valorizzate la nazione e il numero di targa twin
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        (!self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin || !self.propostaTelepassSrvc.datiPratica.targaTwin)
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si devono valorizzare la nazione e la targa dell`apparato aggiuntivo';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto il apparato aggiuntivo, la targa e la targa twin siano diverse
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        self.propostaTelepassSrvc.datiPratica.targa &&
        self.propostaTelepassSrvc.datiPratica.targaTwin &&
        self.propostaTelepassSrvc.datiPratica.targa === self.propostaTelepassSrvc.datiPratica.targaTwin
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'La targa e la targa twin devono essere diverse';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      if (
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'S'
      ) {
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Indirizzo non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }

      //Controlli dati residenza e documento d'identità

      if (self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti !== null) {
        //verifica dati anagrafici documenti aziendali

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.paese ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.paese.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.provincia ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.provincia.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.comune ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.comune.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Via residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.tipoDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Tipo Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.numeroDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Numero Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita
            .localitaAutoritaRilascioDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune rilascio Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.dataRilascioDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Data rilascio Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.dataScadenzaDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Data scadenza Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }
      if (self.propostaTelepassSrvc.datiCliente.documentoIdentita !== null) {
        //verifica dati anagrafici persona fisica

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.paese ||
          !self.propostaTelepassSrvc.datiCliente.recapito.paese.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.provincia ||
          !self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.comune ||
          !self.propostaTelepassSrvc.datiCliente.recapito.comune.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Via residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.tipoDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Tipo Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.numeroDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Numero Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.rilasciatoDa) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune rilascio Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataRilascio) {
          var message = {};
          message.type = 'E';
          message.message = 'Data rilascio Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataScadenza) {
          var message = {};
          message.type = 'E';
          message.message = 'Data scadenza Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }

      if (errori) {
        return false;
      }

      return true;
    };

    this.findCodiceProvincia = function (descrizioneProvincia) {
      var provincia = self.province.find(function (item) {
        return item.descrizione === descrizioneProvincia;
      });

      return provincia ? provincia.codice : '';
    };

    // this.findCodiceCitta = function(descrizioneCitta) {
    //   var citta = self.comuni.find(function(item) {
    //     return item.descrizione === descrizioneCitta;
    //   });

    //   if (!citta) {
    //     self.spinner.showSpinner = true;

    //     self.domainSrvc
    //       .promiseDomain(
    //         'COMUNE',
    //         self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia
    //       )
    //       .then(function(domain) {
    //         self.comuni = domain;

    //         var c = self.comuni.find(function(item) {
    //           return item.descrizione === descrizioneCitta;
    //         });

    //         self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = c
    //           ? c.codice
    //           : '';
    //       })
    //       .finally(function() {
    //         self.spinner.showSpinner = false;
    //       });
    //   }

    //   return citta ? citta.codice : '';
    // };

    this.selezionaTipoIndirizzo = function () {
      if (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione) {
        // self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = '086';

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione =
          self.propostaTelepassSrvc.datiCliente.recapito.paese.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia =
          self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta =
          self.propostaTelepassSrvc.datiCliente.recapito.comune.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = self.propostaTelepassSrvc.datiCliente.recapito.cap;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = self.propostaTelepassSrvc.datiCliente.recapito.via;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nome = self.propostaTelepassSrvc.datiCliente.recapito.nome;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cognome =
          self.propostaTelepassSrvc.datiCliente.recapito.cognome;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita =
          self.propostaTelepassSrvc.datiCliente.recapito.localita;
      } else {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = null;
      }
    };

    this.selezionaModalitaRitiro = function () {
      if (!self.propostaTelepassSrvc.datiPratica.modalitaRitiro) {
        return;
      }

      // Se la modalità di ritiro è diversa da spedizione non passo i dati di spedizione
      if (self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice !== 'S') {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = null;
      }

      if (self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice !== 'F') {
        self.propostaTelepassSrvc.datiPratica.codiceApparato = null;
        self.propostaTelepassSrvc.datiPratica.codiceApparatoTwin = null;
      }

      if (
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'S' &&
        (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
          self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
      ) {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
        self.selezionaTipoIndirizzo();
      }
    };

    this.onChangeProvincia = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaComuni();
    };

    this.onChangeComune = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaCAP();
    };

    this.onChangeCap = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaLocalita();
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function () {
      self.spinner.showSpinner = true;
      self.comuni = [];
      var provincia =
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia ||
        self.findCodiceProvincia(self.propostaTelepassSrvc.datiCliente.recapito.provincia);

      if (!provincia) {
        self.spinner.showSpinner = false;
        return;
      }

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;

          if (
            self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD' &&
            (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
              self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
          ) {
            self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
            self.selezionaTipoIndirizzo();
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      self.spinner.showSpinner = true;
      self.capFiltrati = [];
      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;

      if (!comune) {
        self.spinner.showSpinner = false;
        return;
      }

      self.domainSrvc
        .promiseDomain('CAP', null, comune)
        .then(function (domain) {
          self.capFiltrati = domain;
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function () {
      self.spinner.showSpinner = true;
      var cap = self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap;
      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.comuni = [];
      self.capFiltrati = [];
      self.localita = [];

      var provincia =
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia ||
        self.findCodiceProvincia(self.propostaTelepassSrvc.datiCliente.recapito.provincia);

      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;
      var cap = self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap;

      // Array di chiamate creato dinamicamente se ci sono i correspondenti dati
      var chiamateDominio = [self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')];

      if (provincia) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('COMUNE', provincia));
      }

      if (comune) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('CAP', null, comune));
      }

      if (cap && comune) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('LOCALITA', cap, comune));
      }

      //chiamata ai domain services in contemporanea
      self.spinner.showSpinner = true;
      $q.all(chiamateDominio)
        .then(function (responses) {
          self.paesi = responses[0];

          // Rimuovo la provincia 'STATO ESTERO'
          self.province = responses[1].filter(function (item) {
            return item.codice !== '**';
          });

          self.comuni = responses[2];
          if (
            self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD' &&
            (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
              self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
          ) {
            self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
            self.selezionaTipoIndirizzo();
          }

          self.capFiltrati = responses[3];

          self.localita = responses[4];
          if (self.localita) {
            if (!self.localita.length) {
              self.localita.push({
                codice: comune.codice,
                descrizione: comune.descrizione
              });
            }
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    this.recuperaModalitaRitiro = function () {
      self.definizioneSrvc
        .promiseRecuperaModalitaRitiro(
          self.propostaTelepassSrvc.datiProdotto.codiceProdottoCPT,
          self.propostaTelepassSrvc.datiPratica.settore
        )
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }

          self.modalitaRitiroList = response.data.result.map(function (item) {
            return item.codice;
          });
        });
    };

    this.isClienteEstero = function () {
      return self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice === '**';
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function () {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione) {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione = {};
      }

      if (self.propostaTelepassSrvc.datiCliente.documentoIdentita) {
        self.dataRilascioDocumento = self.propostaTelepassSrvc.formattazioneData(
          self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataRilascio
        );

        self.dataScadenzaDocumento = self.propostaTelepassSrvc.formattazioneData(
          self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataScadenza
        );
      }

      console.log(self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti);
      if (
        self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti &&
        self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti.length
      ) {
        for (var index in self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti) {
          self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[
            index
          ].documentoIdentita.dataRilascioDocumento = self.propostaTelepassSrvc.formattazioneData(
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].documentoIdentita
              .dataRilascioDocumento
          );

          self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[
            index
          ].documentoIdentita.dataScadenzaDocumento = self.propostaTelepassSrvc.formattazioneData(
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].documentoIdentita
              .dataScadenzaDocumento
          );

          if (
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].recapito.provincia.codice === '**'
          ) {
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].recapito.comune = {
              codice: '**',
              descrizione: 'STATO ESTERO'
            };
          }
        }

        if (!self.propostaTelepassSrvc.datiPratica.ndgReferente) {
          self.propostaTelepassSrvc.datiPratica.ndgReferente =
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].ndg;
        }
      }
      self.recuperaModalitaRitiro();

      self.recuperaDomini();

      // Fix 21-04-2021
      if (self.isClienteEstero()) {
        self.propostaTelepassSrvc.datiCliente.recapito.comune.codice = '**';
        self.propostaTelepassSrvc.datiCliente.recapito.comune.descrizione = 'STATO ESTERO';
        // Reset dati spedizione
        self.propostaTelepassSrvc.datiPratica.datiSpedizione = {
          cap: '',
          citta: '',
          civico: null,
          cognome: self.propostaTelepassSrvc.datiPratica.datiSpedizione.cognome,
          flIndirizzoSpedizione: false,
          localita: '',
          nazione: '',
          nome: self.propostaTelepassSrvc.datiPratica.datiSpedizione.nome,
          provincia: '',
          via: ''
        };
      }
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  tlpsDatiAggiuntiviCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    '$state',
    'TlpsDomainSrvc',
    '$q',
    'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDatiAggiuntivi/tlpsDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDatiAggiuntiviComponent = {
    bindings: {},
    controller: tlpsDatiAggiuntiviCtrl,
    controllerAs: 'datiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsDatiAggiuntivi', tlpsDatiAggiuntiviComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsDefinizione/tlpsDatiAggiuntivi/tlpsDatiAggiuntivi.cmpt.js
// module id = 27
// module chunks = 0